/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.33.0.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

import { Decimal, Addr, InstantiateMsg, ContractConfig, ExecuteMsg, ExecMsg, OrderType, Uint128, QueryMsg, QueryMsg1, ArrayOfTupleOfTupleOfUint128Anduint128AndNull } from "./LootboxMarketContract.types";
import { CamelCasedProperties } from "type-fest";
export abstract class LootboxMarketContractExecuteMsgBuilder {
  static placeOrder = ({
    lootbox,
    market,
    orderType,
    price,
    quote
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    place_order: unknown;
  }>["place_order"]>): ExecuteMsg => {
    return {
      place_order: ({
        lootbox,
        market,
        order_type: orderType,
        price,
        quote
      } as const)
    };
  };
  static removeOrder = ({
    orderId
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    remove_order: unknown;
  }>["remove_order"]>): ExecuteMsg => {
    return {
      remove_order: ({
        order_id: orderId
      } as const)
    };
  };
  static adminUpdateConfig = ({
    config
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    admin_update_config: unknown;
  }>["admin_update_config"]>): ExecuteMsg => {
    return {
      admin_update_config: ({
        config
      } as const)
    };
  };
}
export abstract class LootboxMarketContractQueryMsgBuilder {
  static getOrderBook = ({
    denom,
    limit,
    lootbox,
    order,
    orderType,
    startAfter
  }: CamelCasedProperties<Extract<QueryMsg, {
    get_order_book: unknown;
  }>["get_order_book"]>): QueryMsg => {
    return {
      get_order_book: ({
        denom,
        limit,
        lootbox,
        order,
        order_type: orderType,
        start_after: startAfter
      } as const)
    };
  };
}